/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IMandsFooterCopyrightData } from './mands-footer-copyright.data';
import { IMandsFooterCopyrightProps } from './mands-footer-copyright.props.autogenerated';

/**
 *
 * MandsFooterCopyright component
 * @extends {React.PureComponent<IMandsFooterCopyrightProps<IMandsFooterCopyrightData>>}
 */
export default class MandsFooterCopyright extends React.PureComponent<IMandsFooterCopyrightProps<IMandsFooterCopyrightData>> {
    public render(): JSX.Element {
        const {
            config: { copyRightLines }
        } = this.props;

        return (
            <div className='row'>
                <div className='copyright'>
                    {copyRightLines &&
                        copyRightLines.map((copyRightLine: string, index: number) => {
                            return <p key={index}>{copyRightLine}</p>;
                        })}
                </div>
            </div>
        );
    }
}
